module.exports = __webpack_public_path__ + "img/2D.ff779911.png";